import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
import { Grid } from './Grid'
import styles from './DataGrid.less'
import { GridCell } from './GridCell'
import { Button } from './Button'

function equalizeIt (parentEl, childEl) {
  if (parentEl) {
    var els = parentEl.querySelectorAll(childEl)

    if (els.length === 0) {
      return
    }
    var row = []
    var max
    var top

    // eslint-disable-next-line no-inner-declarations
    function setHeights () {
      row.forEach(function (e) {
        e.style.height = max + 'px'
      })
    }

    for (var i = 0; i < els.length; i++) {
      var el = els[i]
      el.style.height = 'auto'
      if (el.offsetTop !== top) {
        // new row detected
        setHeights()
        top = el.offsetTop
        max = 0
        row = []
      }
      row.push(el)
      max = Math.max(max, el.offsetHeight)
    }
    setHeights() // last row
  }
}

export class DataGrid extends React.Component {
  constructor (props) {
    super(props)

    this.gridObserver = null
    this.gridEl = null
  }

  setGridObserver (element) {
    const { equalize = true, equalizeTarget = '*.equalize-watch' } = this.props
    // if no equalize then just exit
    if (!equalize) {
      this.gridObserver = null
      this.gridEl = null
      return
    }

    if (element && !this.gridObserver) {
      // eslint-disable-next-line no-undef
      this.gridObserver = new ResizeObserver((entries) => {
        equalizeIt(element, equalizeTarget)
      })
      this.gridObserver.observe(element)
      this.gridEl = element
    } else if (!element && this.gridObserver) {
      this.gridObserver.disconnect()
      this.gridObserver = null
      this.gridEl = null
    }
  }

  static pt = {
    data: pt.array,
    renderDataItem: pt.func.isRequired,
    onLoadMore: pt.func,
    onSelectionChanged: pt.func,
    onDataItemChangedProcessing: pt.func,
    onDataChangedTest: pt.func,
    onDataChanged: pt.func,
    onDataChangedProcessing: pt.func,
    loading: pt.bool.isRequired,
    cardStyles: pt.string.isRequired,
    children: pt.any
  }

  static defaultProps = {
    loading: false,
    cardStyles: 'Auto' // Fixed, Fluid, Auto
  }

  componentDidUpdate (prevProps) {
    const { data: prevData } = prevProps
    const { data: currentData, onSelectionChanged, onDataItemChangedProcessing, onDataChangedTest, onDataChanged, equalize = true, equalizeTarget = '*.equalize-watch' } = this.props
    const items = {
      prevItems: prevData || [],
      currentItems: currentData || []
    }

    if (_.isFunction(onDataItemChangedProcessing)) {
      const ret = onDataItemChangedProcessing(items.prevItems, items.currentItems)
      items.prevItems = ret.prevItems
      items.currentItems = ret.currentItems
    }

    if (_.isFunction(onSelectionChanged)) {
      let selectedPrevItems = _.filter(items.prevItems, { Selected: true })
      let selectedCurrentItems = _.filter(items.currentItems, { Selected: true })

      if (selectedPrevItems.length !== selectedCurrentItems.length) {
        onSelectionChanged(selectedCurrentItems)
      }
    }

    if (_.isFunction(onDataChanged) & _.isFunction(onDataChangedTest)) {
      let dataPrevItems = _.filter(items.prevItems, onDataChangedTest)
      let dataCurrentItems = _.filter(items.currentItems, onDataChangedTest)

      if (dataPrevItems.length !== dataCurrentItems.length) {
        if (equalize) {
          equalizeIt(this.gridEl, equalizeTarget)
        }
        onDataChanged(dataCurrentItems)
      }
    }
  }

  renderLoadMore (results) {
    const { 'data-tid': testId = '', onLoadMore } = this.props

    if (_.isArray(results) === false) {
      return null
    }

    return <Grid marginX>
      <GridCell small={12} className="text-center">
        <Button data-tid={`${testId}_loadmore`} onClick={onLoadMore}><i className="fas fa-caret-down"></i>&nbsp; Load more ...</Button>
      </GridCell>
    </Grid>
  }

  render () {
    const { data, hasMore, renderDataItem, children, loading, smallUp = 2, mediumUp = 4, largeUp = 3 } = this.props
    let items = _.compact(_.map(data || [], (a, i) => { return renderDataItem(a, i, (data || []).length) }))

    if (loading) {
      return <div key='loading' className={styles.loadingWrapper}>
        <img className="loading-animation-small" src="/content/images/LogoSymbol.png" />
      </div>
    }

    return (
      <>
      <Grid paddingX ref={this.setGridObserver} smallUp={smallUp} mediumUp={mediumUp} largeUp={largeUp}>
        {items.length > 0
          ? items
          : children
        }
      </Grid>
      {hasMore
        ? this.renderLoadMore(data)
        : null
      }
      </>
    )
  }
}
